import Image from "next/image";
import React from "react";
import Graph from "../../public/images/invest/building-percentage.svg";

const Manufacturing = ({ setModalOpen }) => {
  return (
    <div className="pt-10 pb-40">
      <div className="flex gap-10 text-[#282d35]">
        <div className="w-[55%] flex items-center">
          <Image src={Graph.src} alt="" width="700" height="700" />
        </div>
        <div className="flex flex-col w-[45%] gap-5">
          <div className="text-lg font-bold">
            Manufacturing needs to catch up
          </div>
          <div className="text-5xl font-extrabold leading-tight">
            Huge opportunity
            <br /> to revolutionize manufacturing
          </div>
          <div className="font-semibold leading-loose">
            The manufacturing industry is lagging behind in terms of digital
            technologies, as many of its systems and tools are outdated and
            difficult to use. In some cases, it can be faster for contractors to
            perform tasks manually rather than relying on digital tools.
            However, the EasyDuct App is a notable exception, as it has
            introduced a{`"nothing-to-learn"`} technology that is incredibly
            user-friendly, even easier than a coloring book.
          </div>
          <div>
            <button className="sign-up-btn" onClick={setModalOpen}>
              Sign Up to Invest
            </button>
          </div>
        </div>
      </div>
      <div className="text-center text-[#8E8E8E] mt-32 leading-loose">
        <div>
          {
            "* This data was sourced from https://www.zippia.com/advice/digital-transformation-statistics/"
          }
        </div>
        <div>
          {
            "** This data was sourced from https://visionx.sibvisions.com/digital-gap-manufacturing-part-1-production-organizations-lag/"
          }
        </div>
      </div>
    </div>
  );
};

export default Manufacturing;
